import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=b574a4a6&scoped=true&"
import script from "./Permission.vue?vue&type=script&lang=ts&"
export * from "./Permission.vue?vue&type=script&lang=ts&"
import style0 from "./Permission.vue?vue&type=style&index=0&id=b574a4a6&lang=sass&scoped=true&"
import style1 from "./Permission.vue?vue&type=style&index=1&id=b574a4a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b574a4a6",
  null
  
)

export default component.exports